// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var state = {
  productDetail: null
};
var mutations = {
  SET_PRODUCT_DETAIL: function SET_PRODUCT_DETAIL(state, detail) {
    state.productDetail = detail;
  }
};
var actions = {
  // 可以在这里添加异步操作
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};